import { SignoutIcon } from '@cp/ds/src/icons';
import React from 'react';
import { Button, ButtonProps } from '@cp/ds/src/components/button';
import { useLogout } from '../model';

export interface LogoutButtonProps extends ButtonProps {}
export const LogoutButton: React.FC<LogoutButtonProps> = (props) => {
  const { logout, isLoading } = useLogout();
  return <Button disabled={isLoading} iconRight={<SignoutIcon />} onClick={isLoading ? undefined : logout} variant="text" {...props} />;
};
